/**
 * Connected Inventory Display Helper
 * Shows real-time connected inventory status on frontend
 * (Backend webhook handles actual inventory synchronization)
 */

window.ConnectedInventory = (function() {

  var skuGroups = {};
  var currentProduct = null;

  function init(productData) {
    if (!productData || !productData.variants) return;

    currentProduct = productData;
    buildSkuGroups();
    displayConnectedInfo();
  }

  function buildSkuGroups() {
    skuGroups = {};

    currentProduct.variants.forEach(function(variant) {
      if (variant.sku) {
        if (!skuGroups[variant.sku]) {
          skuGroups[variant.sku] = [];
        }
        skuGroups[variant.sku].push(variant);
      }
    });
  }

  function displayConnectedInfo() {
    // Inventory grouping remains available internally. No promotional shipping
    // message should be injected into the product form.
  }

  function interceptSelectCallback(originalCallback) {
    return function(variant, selector) {
      // Let the original callback handle normal functionality
      if (originalCallback) {
        originalCallback.call(this, variant, selector);
      }

      // Add our connected inventory display logic
      displayVariantConnections(variant);
    };
  }

  function displayVariantConnections(variant) {
    if (!variant || !variant.sku) return;

    var connectedVariants = skuGroups[variant.sku] || [];

    if (connectedVariants.length > 1) {
      var connectedInfo = document.querySelector('.connected-variants-info');
      if (!connectedInfo) {
        connectedInfo = document.createElement('div');
        connectedInfo.className = 'connected-variants-info';
        connectedInfo.style.cssText = `
          font-size: 12px;
          color: #666;
          margin-top: 5px;
          font-style: italic;
        `;

        var skuElement = document.querySelector('.product-sku, .sku');
        if (skuElement && skuElement.parentNode) {
          skuElement.parentNode.insertBefore(connectedInfo, skuElement.nextSibling);
        }
      }

      var availableCount = connectedVariants.filter(function(v) {
        return v.available && v.inventory_quantity > 0;
      }).length;

      connectedInfo.innerHTML = `
        Connected with ${connectedVariants.length - 1} other variant(s)
        (${availableCount}/${connectedVariants.length} available)
      `;
    }
  }

  return {
    init: init,
    interceptSelectCallback: interceptSelectCallback,
    displayConnectedInfo: displayConnectedInfo
  };
})();
